import { CLIENTS_URL, SYSTEM_ROLES } from 'constants/globals';
import { arrayValidation } from 'utils/array';
import {
  BACK_URL_PATHS,
  TITLE_MAP,
  BACK_URLS,
  NEW_CLIENT_PATHS,
  ONBOARDING_PATHS,
  POSITIONS_PATHS,
  DOCUMENTARY_PATHS,
  COOWNERS_PATHS,
} from './constants';

// Constantes para las URLs de regreso

export const getTitleFromPath = (currentPath: string, role: string): string => {
  if (role === SYSTEM_ROLES.cliente && currentPath === '/') {
    return 'Mi Portafolio';
  }

  if (TITLE_MAP[currentPath]) {
    return TITLE_MAP[currentPath];
  }

  if (String(currentPath).includes('/clientes')) {
    return 'Clientes';
  }

  if (String(currentPath).includes('/fondos')) {
    return 'Fondos';
  }

  return '';
};

export const shouldShowBackButton = (
  currentPath: string,
  clientSeleted: any,
): boolean => {
  if (BACK_URL_PATHS.some((path) => currentPath.includes(path))) {
    return true;
  }

  if (currentPath === '/portafolio-modelo/documental' && clientSeleted) {
    return true;
  }

  if (currentPath === '/portafolio-modelo/ordenes-globales') {
    return true;
  }

  if (currentPath === '/portafolio-fondos/ordenes-globales') {
    return true;
  }

  return false;
};

export const isPathIncluded = (paths: string[], currentPath: string) => {
  return paths.some((path) => currentPath.includes(path));
};

const handleCoOwnersBackUrl = (currentPath: string): string => {
  if (CLIENTS_URL.coOwnersBack) {
    return CLIENTS_URL.coOwnersBack;
  }

  const splitCurrentPath = String(currentPath).split('/cotitular');

  if (splitCurrentPath && arrayValidation(splitCurrentPath)) {
    return splitCurrentPath[0];
  }

  return BACK_URLS.NEW_CLIENT;
};

const getRouteContext = (currentPath: string): string => {
  if (String(currentPath).includes('/clientes')) {
    return BACK_URLS.CLIENTS;
  }

  if (String(currentPath).includes('/fondos')) {
    return BACK_URLS.FUNDS;
  }

  return BACK_URLS.REBALANCE;
};

const handlePositionsAndOnboardingBackUrl = (
  currentPath: string,
  isPositionsPath: boolean,
  isOnboardingPath: boolean,
): string => {
  if (isPositionsPath || isOnboardingPath) {
    return getRouteContext(currentPath);
  }

  return BACK_URLS.REBALANCE;
};

export const getBackUrl = ({
  currentPath,
  isCurrentCoOwners,
  isPositionsPath,
  isDocumentary,
}: {
  currentPath: string;
  isCurrentCoOwners: boolean;
  isPositionsPath: boolean;
  isDocumentary: boolean;
}): string => {
  if (isCurrentCoOwners) {
    return handleCoOwnersBackUrl(currentPath);
  }

  const isNewClientPath = isPathIncluded(NEW_CLIENT_PATHS, currentPath);

  if (isNewClientPath) {
    return BACK_URLS.ONBOARDING;
  }

  if (isDocumentary) {
    return BACK_URLS.CLIENTS;
  }

  const isOnboardingPath = isPathIncluded(ONBOARDING_PATHS, currentPath);
  if (isPositionsPath || isOnboardingPath) {
    return handlePositionsAndOnboardingBackUrl(
      currentPath,
      isPositionsPath,
      isOnboardingPath,
    );
  }

  return String(currentPath).includes('fondos')
    ? BACK_URLS.FUND_REBALANCE
    : BACK_URLS.REBALANCE;
};

export const getPathFlags = (currentPath: string) => {
  return {
    isPositionsPath: isPathIncluded(POSITIONS_PATHS, currentPath),
    isDocumentary: isPathIncluded(DOCUMENTARY_PATHS, currentPath),
    isCurrentCoOwners: isPathIncluded(COOWNERS_PATHS, currentPath),
    isOnboardingPath: isPathIncluded(ONBOARDING_PATHS, currentPath),
    isNewClientPath: isPathIncluded(NEW_CLIENT_PATHS, currentPath),
  };
};
